import React, { useState, useEffect, useRef } from 'react';
import bigrow from "../assets/whitearow5.png";
import Q from "../assets/image/Qstar.png";
import Green from "../assets/green.png"
import L from "../assets/dashline10.png"
import L2 from "../assets/dasgline5.png"
import Frame from "../assets/image/borderframe.png"
import { useNavigate } from 'react-router-dom';


export default function PoweredBy() {
  const navigate = useNavigate()
  const [scrollProgress, setScrollProgress] = useState(0);
  const textSectionRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!textSectionRef.current) return;

      const section = textSectionRef.current;
      const rect = section.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      const sectionTop = rect.top;
      const sectionHeight = rect.height;

      // Start animation when section is 80% visible from bottom
      const startPoint = windowHeight * 0.8;
      const endPoint = -sectionHeight + windowHeight * 0.4;

      if (sectionTop <= startPoint && sectionTop >= endPoint) {
        const progress = (startPoint - sectionTop) / (startPoint - endPoint);
        setScrollProgress(Math.max(0, Math.min(1, progress)));
      } else if (sectionTop > startPoint) {
        setScrollProgress(0);
      } else if (sectionTop < endPoint) {
        setScrollProgress(1);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const content = [
  
    { text: "We help business owners access money quickly. Whether it's to grow, manage cash flow, or grab new opportunities, we're here to make funding easy.", type: "body" }
  ];

  const getWordOpacity = (wordIndex, totalWords) => {
    const wordProgress = wordIndex / totalWords;
    return scrollProgress >= wordProgress ? 1 : 0.15;
  };

  const renderAnimatedText = () => {
    let globalWordIndex = 0;
    const allWords = content.reduce((acc, line) => acc + line.text.split(' ').length, 0);

    return content.map((line, lineIndex) => {
      const words = line.text.split(' ');
      
      if (line.type === "heading") {
        return (
          <div key={lineIndex} className="mb-2">
            <p className="text-black font-alton font-bold text-[26px] sm:text-[30px] md:text-[30px] lg:text-[36px]">
              {line.hasIcon && (
                <span className="inline-flex items-center justify-center mr-2">
                  <span className="relative inline-block w-[55px] h-[55px] sm:w-[60px] sm:h-[60px] md:w-[64px] md:h-[64px] lg:w-[67px] lg:h-[67px] rounded-[15px] border border-[#EDC938] border-[4px] rotate-[15deg] align-middle -mt-1">
                    <span className="absolute inset-0 flex items-center justify-center bg-white rounded-[11px]">
                      <img 
                        src={Q} 
                        alt="Q Star Logo" 
                        className="w-[46px] h-[46px] sm:w-[52px] sm:h-[52px] md:w-[54px] md:h-[54px] lg:w-[56px] lg:h-[56px]" 
                      />
                    </span>
                  </span>
                </span>
              )}
              {words.map((word, wordIndex) => {
                const currentWordIndex = globalWordIndex++;
                const opacity = getWordOpacity(currentWordIndex, allWords);
                return (
                  <span
                    key={wordIndex}
                    style={{
                      opacity: opacity,
                      color: opacity > 0.5 ? '#000000' : '#d1d5db',
                      transition: 'opacity 0.3s ease, color 0.3s ease'
                    }}
                  >
                    {word}
                    {wordIndex < words.length - 1 && ' '}
                  </span>
                );
              })}
            </p>
          </div>
        );
      } else {
        return (
          <p key={lineIndex} className="font-inter font-normal text-black leading-relaxed text-[26px] sm:text-[30px] md:text-[40px] lg:text-[38px]">
            {words.map((word, wordIndex) => {
              const currentWordIndex = globalWordIndex++;
              const opacity = getWordOpacity(currentWordIndex, allWords);
              return (
                <span
                  key={wordIndex}
                  style={{
                    opacity: opacity,
                    color: opacity > 0.5 ? '#000000' : '#000000CC'
,
                    transition: 'opacity 0.3s ease, color 0.3s ease'
                  }}
                >
                  {word}
                  {wordIndex < words.length - 1 && ' '}
                </span>
              );
            })}
          </p>
        );
      }
    });
  };

  return (
    <section id='about' className="bg-white pt-[140px] sm:pt-[140px] md:pt-[160px] lg:pt-[140px] pb-[60px]">
      <div className="max-w-[1280px] mx-auto px-2 sm:px-5 md:px-5 lg:px-5 sm:max-w-[810px] md:max-w-[810px] lg:max-w-[1280px]">
        <div className="flex items-center  justify-center -mb-4 sm:-mb-4 md:-mb-5 lg:-mb-5 gap-4">
          <div className="bg-[#149D64] rounded-tl-[40px] rounded-tr-[10px] rounded-bl-[10px] rounded-br-[10px] flex items-center justify-center relative overflow-hidden w-[80px] h-[82px] sm:w-[90px] sm:h-[92px] sm:rounded-tl-[32px] md:w-[102px] md:h-[104px] md:rounded-tl-[40px] lg:w-[102px] lg:h-[104px] lg:rounded-tl-[40px]">
            <img src={Green} alt="" className="w-full h-full" />
          </div>
          <div className="text-black font-alton text-[36px] font-normal leading-tight tracking-[-2px] sm:text-[40px] md:text-[40px] lg:text-[50px]">
            <div>Reap</div>
            <div>Capital</div>
          </div>
        </div>

        <div className="relative w-fit h-fit mx-auto text-center rounded-lg flex flex-col items-center justify-center overflow-hidden pt-[30px] px-[0px] pb-[0px] sm:px-[0px] sm:pb-[30px] md:px-[20px] md:pb-[20px] lg:px-[30px] sm:pb-[30px]"
        >
            <img src={Frame} alt="" className="absolute right-0 top-0 buttom-0 left-0 w-full  h-full" />

          <div 
            ref={textSectionRef}
            className="relative max-w-full sm:max-w-[500px] md:max-w-[600px] lg:max-w-[667px] mx-auto text-center rounded-lg flex flex-col items-center justify-center px-[16px] sm:px-[18px] md:px-[20px] lg:px-[30px] pt-[20px] sm:pt-[25px] md:pt-[30px] lg:pt-[30px] pb-[60px] sm:pb-[100px] md:pb-[100px] lg:pb-[70px]"
          >
            {/*<img src={L} alt="" className="absolute -bottom-2 w-fit max-w-[667px] h-fit" />
            <img src={L} alt="" className="absolute -top-2 w-fit max-w-[667px] h-fit" />
            <img src={L2} alt="" className="absolute -left-3 w-fit max-w-[667px] h-fit" />
            <img src={L2} alt="" className="absolute -right-3 w-fit max-w-[667px] h-fit" />

            <div className="absolute -top-2 -left-2 w-5 h-5 bg-emerald-500 rounded-full z-20 border-[6px] border-white shadow-lg shadow-gray-500/70"></div>
            <div className="absolute -top-2 -right-2 w-5 h-5 bg-emerald-500 rounded-full z-20 border-[6px] border-white shadow-lg shadow-gray-500/70"></div>
            <div className="absolute -bottom-2 -left-2 w-5 h-5 bg-emerald-500 rounded-full z-20 border-[6px] border-white shadow-lg shadow-gray-500/70"></div>
            <div className="absolute -bottom-2 -right-2 w-5 h-5 bg-emerald-500 rounded-full z-20 border-[6px] border-white shadow-lg shadow-gray-500/70"></div>
            */}

            <div className="max-w-[515px] mx-auto flex flex-col items-center justify-center text-center">
               <div class="mb-2 ">
      <p class="text-black font-alton font-bold 
    text-[26px] sm:text-[30px] md:text-[30px] lg:text-[36px] ">
        Reap Capital is powered by
      </p>

      <div class="flex items-center justify-center gap-2">
        <div class="relative w-[55px] h-[55px] sm:w-[60px] sm:h-[60px] md:w-[64px] md:h-[64px] lg:w-[67px] lg:h-[67px]
              rounded-[15px] border border-[#EDC938] border-[4px] rotate-[15deg] pb-[5px] 
              flex items-center justify-center overflow-hidden bg-white">
    <img src={Q} alt="Q Star Logo" 
      class="w-[46px] h-[46px] sm:w-[52px] sm:h-[52px] md:w-[54px] md:h-[54px] lg:w-[56px] lg:h-[56px]" />
  </div>
        <span class="text-black font-alton font-bold 
         text-[26px] sm:text-[30px] md:text-[30px] lg:text-[36px]">Quantum Leap.</span>
      </div>
     </div>
              {renderAnimatedText()}
            </div>
          </div>
        </div>
<div className="flex justify-center items-center my-16 gap-[12px]  sm:gap-[14px] lg:gap-[24px] max-w-[1280px] w-full mx-auto">
          <style>{`
            .bg-gradient-radial {
              background: radial-gradient(ellipse at top center, #149D64 0%, #0B6351 10%);
            }
            .button-default {
              box-shadow:
                0 0 0 0.9px #47ffd48e,
                inset 0 0 20px rgba(25, 180, 140, 1.0),
                inset 0 0 10px rgba(42, 157, 114, 0.7);
            }
            .button-default:hover {
              box-shadow:
                0 0 0 4px #47ffd48e,
                inset 0 0 0px rgba(0, 0, 0, 0),
                inset 0 0 0px rgba(0, 0, 0, 0);
            }
          `}</style>
          <div className='h-[1px] w-full bg-[#8DDFBA]'></div>
          <button className="relative text-xl font-semibold text-white rounded-[18px] min-w-[176px] min-h-[56px] bg-black button-default hover:text-[#2a9d72] cursor-pointer transition-all duration-300 z-20"
          onClick={() => navigate('/contact')}

          >
            Let's Start
          </button>
          <div className='h-[1px] w-full bg-[#8DDFBA]'></div>
        </div>
      </div>
    </section>
  );
}